(function() {
  const menuToggle = document.querySelector('.italian-nav-bar__toggle');
  const menu = document.querySelector('.italian-nav-bar__menu');

  // Check if we're on mobile (matches CSS breakpoint)
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  // Mobile hamburger menu toggle
  if (menuToggle && menu) {
    menuToggle.addEventListener('click', function() {
      const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', !isExpanded);
      menu.classList.toggle('italian-nav-bar__menu--open');
    });
  }

  // Handle dropdown toggles - shared function for both touch and click
  function handleDropdownToggle(link, e) {
    if (!isMobile()) return false;

    const item = link.closest('.italian-nav-bar__item');
    const isOpen = item.classList.contains('italian-nav-bar__item--open');

    // Always prevent default on mobile - we'll navigate via sub-links
    e.preventDefault();

    // Close all other dropdowns
    document.querySelectorAll('.italian-nav-bar__item').forEach(otherItem => {
      if (otherItem !== item) {
        otherItem.classList.remove('italian-nav-bar__item--open');
        const otherLink = otherItem.querySelector('.italian-nav-bar__link--has-dropdown');
        if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
      }
    });

    // Toggle this dropdown
    item.classList.toggle('italian-nav-bar__item--open');
    link.setAttribute('aria-expanded', !isOpen);
    return true;
  }

  document.querySelectorAll('.italian-nav-bar__link--has-dropdown').forEach(link => {
    // Track if touchend already handled this interaction
    let touchHandled = false;

    // Use touchend to bypass iOS Safari's double-tap-for-hover behavior on anchor elements
    link.addEventListener('touchend', function(e) {
      if (isMobile()) {
        touchHandled = true;
        handleDropdownToggle(link, e);
        // Reset flag after a short delay to allow future clicks
        setTimeout(() => { touchHandled = false; }, 300);
      }
    });

    // Keep click handler for non-touch devices and as fallback
    link.addEventListener('click', function(e) {
      // Skip if touchend already handled this
      if (touchHandled) {
        e.preventDefault();
        return;
      }
      handleDropdownToggle(link, e);
    });
  });

  // Desktop: hover behavior for dropdowns
  document.querySelectorAll('.italian-nav-bar__item').forEach(item => {
    const link = item.querySelector('.italian-nav-bar__link--has-dropdown');
    if (link && !isMobile()) {
      item.addEventListener('mouseenter', function() {
        link.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function() {
        link.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Close mobile menu when clicking outside
  document.addEventListener('click', function(e) {
    if (menuToggle && menu && !e.target.closest('.italian-nav-bar')) {
      menuToggle.setAttribute('aria-expanded', 'false');
      menu.classList.remove('italian-nav-bar__menu--open');
      // Also close any open dropdowns
      document.querySelectorAll('.italian-nav-bar__item--open').forEach(item => {
        item.classList.remove('italian-nav-bar__item--open');
      });
    }
  });

  // Helper to update cart count badge
  function updateCartBadge(itemCount) {
    const cartLink = document.querySelector('.italian-nav-bar__cart');
    if (!cartLink) return;

    let countBadge = cartLink.querySelector('.italian-nav-bar__cart-count');

    if (itemCount > 0) {
      if (!countBadge) {
        countBadge = document.createElement('span');
        countBadge.className = 'italian-nav-bar__cart-count';
        cartLink.appendChild(countBadge);
      }
      countBadge.textContent = itemCount;
    } else if (countBadge) {
      countBadge.remove();
    }
  }

  // Subscribe to cart updates to keep cart count badge in sync
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      // Fetch current cart to get accurate item count
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          updateCartBadge(cart.item_count);
        })
        .catch(() => {});
    });
  }
})();
